<template>
  <div class="bbe-sending">
    <div class="bbe-sending__status" v-if="errorText">
      {{errorText}}
    </div>
    <div class="bbe-sending__status" v-else>
      Message sent
      <template v-if="massMailingTotal > 1">{{newMessage.massMailing.sent}} of {{massMailingTotal}}</template>
    </div>
    <i class="email-icon-close bbe-sending__close" @click="hideModal()"/>
  </div>
</template>

<script>
import {cloneDeep, get} from 'lodash'

export default {
  name: 'SendingStatus',
  props: ['errorText', 'close'],
  data () {
    return {
      openStatus: true
    }
  },
  computed: {
    newMessage: {
      get: function () {
        return this.$store.getters.newMessage
      },
      set: function (data) {
        this.$store.dispatch('setNewMessage', data)
      }
    },
    massMailingTotal () {
      return get(this.newMessage, 'massMailing.total', 0)
    }
  },
  methods: {
    hideModal () {
      this.errorText ? this.close() : this.newMessage.status = false
    },
    openNewMessage () {
      const message = cloneDeep(this.newMessage)
      message.status = 'open'
      this.newMessage = message
    }
  },
  beforeMount () {
    const hideModal = this.errorText ? this.close : this.hideModal
    setTimeout(hideModal, 10000)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-sending {
    @include global-font;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 30px;
    left: 30px;
    height: 60px;
    background: $color-mine-shaft;
    border-radius: 3px;
    box-shadow: 0 0 20px rgba($color-accent, 0.25);
    color: $color-white;
    padding: 0 16px 0 20px;
    z-index: 100;
    cursor: default;

    &__status {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 19px;
      margin-right: 30px;
    }

    &__close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 25px;
      height: 25px;
      font-size: 11px;
      cursor: pointer;
      transition: .2s;

      &:hover {
        opacity: 0.5;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/SendingStatus/SendingStatus.vue